<template>
  <div class="height-set-for-component">
  <div class="d-flex">
      <div class="search-bar-comm-style col-md-6" style="display:inline-flex">
            <Multiselect
            v-model="filteredBinType"
            :options="binTypes"
            :searchable="true"
            :close-on-select="true"
            :allow-empty="false"
            @select="handleBinTypeFilter($event,false)"
            label="label"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            :placeholder="$t('Bin Type')"
            track-by="type"
            style="margin-top: 7px;">
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
            </div>
            <span slot="noResult">No results.</span>
          </Multiselect>
      </div>
      <div class="primary-btn-style justify-content-end d-inline-flex col-md-6" style="padding:11px;">
          <button class="learn-about-text-styles" @click="openLearnAboutPanel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
              <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
            </svg>
            {{$t('Learn about bins')}}</button>
            <!-- <button class="btn btn-outline-danger mt-2 mr-2" style="border: 1px solid #831515;"  v-on:click="deleteBinBth()">Delete</button> -->
            <!-- <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;"  v-on:click="editBin('bins-info')">Edit</button> -->
          <button class="btn btn-outline-primary m-2" v-on:click="changeToSelectedBinComponent('add-bin')">{{$t('Add')}}</button>
      </div>
  </div>
  <div class="pl-4 h-100 pt-0 pr-4 pb-2" style="overflow:auto;height:calc(100% - 70px) !important;">
    <table class="table-with-border table-scroll small-first-col" style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th style="width:25%" class="text-left">{{$t('Bin Id')}}</th>
          <th style="width:25%">{{$t('Bin Name')}}</th>
          <th style="width:20%">{{$t('Bin Type')}}</th>
          <th style="width:15%">{{$t('Status')}}</th>
          <th style="width:15%"></th>
        </tr>
      </thead>
      <tbody class="body-half-screen">
        <tr v-for="key in binsList" :key="key.bin_id"
          @click="selectRow(key), changeToSelectedBinComponent('bins-info', key)"
          :class="{activeclass: activeRow == key.bin_id}"
         :id="key.bin_id" class="comm-user-row show-delete-icon" 
         >
         <!-- @dblclick="changeToSelectedBinComponent('bins-info', key)" -->
          <td class="text-left">
            {{key.bin_id }}
          </td>
          <td>{{key.bin_name }}</td>
          <td style="text-transform: capitalize;">
            <template v-if="key.bin_type == 'deployment'">{{$t('Target')}}</template>
            <template v-else>{{key.bin_type}}</template>
          </td>
           <td :class="{ activestatus: key.status === 'active' }" style="color: #cb0707; text-transform: capitalize;">
            <template v-if="key.status === 'active'">{{ key.status }}</template>
            <template v-else>{{$t('Inactive')}}</template>
          </td>
          <td style="position: relative;display:inline-flex;justify-content:center">
            <!-- <div class="dropdown">
              <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="float:inline-start">
                <svg width="15" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots more-actions-btn"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                </svg>
              </div>
              <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                    <a class="dropdown-item p-2" @click.stop.prevent="deleteBin(key.bin_id)">
                      <svg width="15" height="15" viewBox="0 0 16 16" class="bi bi-trash-fill" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                      </svg>
                      Delete
                    </a>
              </div>
            </div> -->
            <svg  @click.stop.prevent="changeToSelectedBinComponent('bins-info', key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16">
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
            </svg>
            <svg @click.stop.prevent="deleteBin(key.bin_id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-row-delete" viewBox="0 0 16 16">
                <title>{{$t('Delete')}}</title>
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div>
      <pagination
        v-model="page"
        :records="totalBins"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
        style="margin-top:10px"
      />
  </div>
  <component :is="selectedComponenet" @close="closeLearnAboutPanel"></component>
  </div>
</template>


<script>
import { mapActions, mapMutations } from "vuex";
import Utils from "../../components.utils.js"
import Multiselect from 'vue-multiselect';
import LearnAbout from "./LearnAboutBins.vue";
import Pagination from "vue-pagination-2";
import {NotifierConstants} from "../../components.constants.js";

 
export default {
  name:'MultiSelect',
  props:['binId'],
  data(){
    return {
      activeIndex: null,
      binData: [],
      page: 1,
      totalPages: -1,
      totalBins: -1,
      perPage: -1,
      options:{chunk:5},
      search:{label:"All",type:"all"},
      binsList: [],
      selectedRowDetails:{},
      activeRow:null,
      filteredBinType:{label:"All",type:"all"},
      selectedComponenet:null,
      binTypes:[
      {label:"All",type:"all"},
      {label:"Asset",type:"asset"},
      {label:"Archive",type:"archive"},
      {label:"Proxy",type:"proxy"},
      {label:"Target",type:"deployment"}
      ]
    };
  },
  components:{
    pagination: Pagination,
    "Multiselect":Multiselect,
    "learn-about":LearnAbout
  },
  methods: {
    handleBinTypeFilter(option){
      this.page = 1;
      this.updateBinsList(option, false)
    },
    openLearnAboutPanel(){
      this.selectedComponenet = 'learn-about';
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
    },
    closeLearnAboutPanel(){
      this.selectedComponenet = null;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },
    selectionLabelCallback(option){
        return `${option.label}`
    },
    changeToSelectedBinComponent(compName, binInfo){
      this.$emit("changeToSelectedBinComponent", compName, binInfo)
    },
    editBin(comp){
      if(this.selectedRowDetails.bin_id != undefined){
        this.changeToSelectedBinComponent(comp,this.selectedRowDetails)
      }else{
        alert("Select Bin to edit");
        return false;
      }
    },
    selectRow(key){
      this.selectedRowDetails = key;
      this.activeRow = key.bin_id;
    },
    deleteBinBth(){
      if(this.activeRow != undefined){
        this.deleteBin(this.selectedRowDetails.bin_id)
      }else{
        alert("Select Bin to delete");
        return false;
      }
    },
    deleteBin(binId) {
      if (confirm(`Are You sure you want to delete the selected bin : "${binId}" ?`)) {
        this.deleteExistingBin({ _id: binId }).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)){
            this.$toast.success(data.message);
          } else{
            this.$toast.error(data.message);
          }
        });
        // this.updateBinsList()
      }
    },
    addBinToList(bin_info){
      let bin_exists = this.binsList.filter((bin)=>bin.bin_id==bin_info.bin_id)
      if (bin_exists.length ==0){
        this.binsList.push(bin_info)
      }else{
        Object.assign(bin_exists[0], bin_info)
      }
    },
    paginate() {
      this.updateBinsList(this.filteredBinType, true);
    },
    updateBinsList(option, isPageClick=false) {
      let payload = {params:{}}
      if(option != undefined && option.type != "all"){
        payload.params = {"bin_type":option.type}
      }
      if(isPageClick){
        payload.params['page'] = this.page;
      }
      this.getAllBinsFromServer(payload).then((data) => {
        if ("bins" in data) {
          this.totalPages = data["page_count"];
          this.totalBins = data["total_bins"];
          this.perPage = data["bins_per_page"];
          this.binsList = [];
          for (const bin of data.bins) {
            this.addBinToList(bin)
          }
        }
      }); 
    },
    handleBinsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let bin_info = notification.message
        if (notification.message_type == NotifierConstants.binRemovedNotification){
          if(this.filteredBinType.type == bin_info.bin_type || this.filteredBinType.type == "all"){
            this.binsList = this.binsList.filter((bin)=>bin.bin_id!=bin_info.bin_id)
          }
        }else if(notification.message_type == NotifierConstants.binCreatedNotification){
          if(this.filteredBinType.type == bin_info.bin_type || this.filteredBinType.type == "all"){
            this.binsList.push(bin_info);
          }
        }else{
          this.addBinToList(bin_info)
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.binCreatedNotification, NotifierConstants.binModifiedNotification, NotifierConstants.binRemovedNotification],
            callback:this.handleBinsNotification,
            parent:"ShowBins"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.binCreatedNotification, NotifierConstants.binModifiedNotification, NotifierConstants.binRemovedNotification],
            callback:this.handleBinsNotification,
            parent:"ShowBins"})
    },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("bins", ["getAllBinsFromServer", "deleteExistingBin"]),
  },
  created() {
    this.registerforWebsocketNotifications()
    this.updateBinsList({label:"All",type:"all"}, false);
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.activeclass {
  color: $active-blue;
}

.search-bar-comm-style {
  height: 30px;
  position: relative;
  select {
    border: $border-color;
    top: 0%;
    inset-inline-start:8%;
    height: 25px;
    padding-inline-start: 3px;
  }
}

.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  width: 100%;
  thead {
    color: $dull-text-color !important;
    position: relative;
    th{
      position: sticky;
      top: 0;
      z-index:9;
      text-align: start;
      background: $primary-background;
      padding:5px;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr{
      height:40px;
      td{
        text-align: start;
        padding: 5px;
      }
    }
  }
}

.table{
  th{
    border-top:none !important;
  }
  td{
    border-top:none !important;
  }
}

// .table-scroll tr {
//   width: 100%;
//   display: flex;
//   height:54px;
// }

// .table-scroll td,
// .table-scroll th {
//   flex-basis: 100%;
//   flex-grow: 2;
//   display: block;
//   padding: 1rem;
//   text-align: start;
// }

.small-col {
  flex-basis: 10%;
}

.comm-user-row:hover {
  color: $active-blue;
  background: $bg-color-on-hover;
  td:first-child {
    text-decoration: underline;
  }
}

.height-set-for-component {
  height: calc(100% - 50px);
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}

.search-bar-comm-style{
  height:30px;
  padding:16px;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 3%;
    width:30% !important;
  }
  svg{
    position: absolute;
    inset-inline-start:21px;
    top: 71%;
  }
}
.more-actions-div {
  position: absolute;
  height: 30px;
  width: 100px;
  padding: 6px;
  z-index: 99;
  border: $border-color;
  background: $primary-background;
  bottom: 0px;
  inset-inline-start:15%;
  ul {
    list-style-type: none;
    li {
      color: $text-color !important;
    }
    li:hover {
      color: $active-blue !important;
    }
  }
}

 .show-delete-icon:hover{
      position: relative;
      .parent-row-delete,  .parent-row-edit{
          visibility: visible;
      }
  }

  .parent-row-delete, .parent-row-edit{
      margin-inline-start: 3px;
      // position: absolute;
      // inset-inline-end :0px;
      z-index: 1;
      background: #525252;
      border: 1px solid #262626;
      width: 55px;
      height: 44px;
      padding: 12px;
      top: 0px;
      border-radius: 4px;
      visibility: hidden;
      color: #fff;
  }
  
  // .parent-row-edit{
  //     inset-inline-end:54px;
  //     border-radius: 5px 0px 0px 5px;
  // }


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


.activestatus {
  color: $active-green-color !important;
}

.primary-btn-style{
    button{
    height: 35px;
    width: 70px;
    font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

::v-deep{
    .multiselect__content-wrapper{
      display:none;
    }
    .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:40%;
    }
    .multiselect__option--selected{
       background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: relative;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
     .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: $input-field-height;
        min-height: 38px;
    }
    .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}

.learn-about-text-styles{
  width: 200px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  margin-top:10px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
}
</style>